import { useAppDispatch, useAppSelector } from "app/hooks"
import { useFailed, useSuccess } from "features/notification/hooks"
import { getEdamaMealPayloadFromFood } from "model/food/utils/getPayloads/getEdamaMealPayload"
import { logMeal } from "features/meal/mealSlice"
import { getMyMealPayloadFromFood } from "model/food/utils/getPayloads/getMyMealPayloadFromFood"
import {
  FoodCreationMethod,
  IEdamaMealPayload,
  IMyMealPayload,
  IOpenFoodFactMealPayload,
} from "model/food/types/mealPayload.types"
import { LogMealAbleFoodType } from "model/food/types"
import { useSetMealTypeParams } from ".."
import { getOpenFoodFactMealPayloadFromFood } from "model/food/utils/getPayloads/getOpenFoodFactMealFromFood"

export const useLogMealFromFood = (callback?: () => void) => {
  const logMealLoading = useAppSelector((state) => state.meal.logMealLoading)
  const logMealFailed = useAppSelector((state) => state.meal.logMealFailed)
  const logMealSuccess = useAppSelector((state) => state.meal.logMealSuccess)

  const dispatch = useAppDispatch()

  const { mealTypeValue } = useSetMealTypeParams()

  const handleLogMealFromFood = (
    food: LogMealAbleFoodType,
    foodCreationMethod?: FoodCreationMethod,
  ) => {
    let mealPayload:
      | IEdamaMealPayload
      | IMyMealPayload
      | IOpenFoodFactMealPayload
      | null = null

    switch (food.source) {
      case "EDAMAM":
        mealPayload = getEdamaMealPayloadFromFood(food, mealTypeValue)
        break

      case "MY_FOOD":
        mealPayload = getMyMealPayloadFromFood(food, mealTypeValue)
        break

      case "OPEN_FOOD_FACTS":
        mealPayload = getOpenFoodFactMealPayloadFromFood(food, mealTypeValue)

      default:
        break
    }

    if (mealPayload) {
      mealPayload.isManualNutrition = food.isManualNutrition
      
      if (foodCreationMethod) {
        mealPayload.creationMethod = foodCreationMethod
      }
      dispatch(logMeal(mealPayload))
    }
  }

  useFailed(logMealFailed)
  useSuccess(logMealSuccess, { message: "" }, callback)

  return {
    logMealLoading,
    handleLogMealFromFood,
  }
}

export default useLogMealFromFood
